import { useEffect } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import {
  ArrowLeftOnRectangleIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { setEventCalendarScrollable } from 'src/features/dispatch/dispatcher.slice';

export function ToggleCalendarEventScrollableButton() {
  const dispatch = useAppDispatch();
  const isEventCalendarScrollable = useAppSelector(
    (state) => state.dispatcher.isEventCalendarScrollable
  );
  const selectedDate = useAppSelector((state) => state.dispatcher.selectedDate);
  const showToggleCalendarScrollButton = useAppSelector(
    (state) => state.dispatcher.showToggleCalendarScrollButton
  );

  useEffect(() => {
    dispatch(setEventCalendarScrollable(false));
  }, [dispatch, selectedDate]);

  return (
    <>
      {showToggleCalendarScrollButton && (
        <SimpleTooltip
          trigger={
            <div className="flex">
              <Button
                className="!p-0 py-2"
                variant="ghost"
                onClick={() => {
                  dispatch(
                    setEventCalendarScrollable(!isEventCalendarScrollable)
                  );
                }}
                ariaLabel={
                  isEventCalendarScrollable
                    ? 'Collapse Assignments'
                    : 'Expand Assignments'
                }
              >
                {isEventCalendarScrollable ? (
                  <ArrowLeftOnRectangleIcon
                    className="h-5 w-5"
                    data-testid="arrow-left-box-icon"
                  />
                ) : (
                  <ArrowRightOnRectangleIcon
                    className="h-5 w-5"
                    data-testid="arrow-right-box-icon"
                  />
                )}
              </Button>
            </div>
          }
          content={
            isEventCalendarScrollable
              ? 'Collapse Assignments'
              : 'Expand Assignments'
          }
        />
      )}
    </>
  );
}
